

import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updatePaymentData } from "../../../../../features/addLoad/addLoadSlice"
import { useEffect, useState } from "react"
import { NumericFormat } from 'react-number-format';
import { useSelector } from "react-redux";
import { showModal } from "../../../../../features/modal/modalSlice";
const Container = styled.div`
    width: 240px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const YukVerenFiyatInput = ({data, isRequired, name, labelText="Yük Veren Fiyatı"}) => {

    const dispatch = useDispatch()
    const [text, setText] = useState(data?.yukverenFiyat)
    const {showErrors, showRequiredPlaces} = useSelector(state => state.addLoad)
    const [isError, setIsError] = useState(false) 
    const freightInfo = JSON.parse(localStorage.getItem("freightInfo"))

    useEffect(()=> {
        setText(data.yukverenFiyat)
    },[data.yukverenFiyat])


    const handleChange = (e) => {
        setText(e.target.value)
        dispatch(updatePaymentData({yukverenFiyat: e.target.value.replace(/[^0-9]/g, '')}))
    }

    useEffect(() => {
        //! bu submit esnasında boş girerse gösterilecek 
        if(isRequired && data?.yukverenFiyat === "" && showErrors){
            return setIsError(true)
        }
        //! bu kullanıcı zorunlu alanları görüntülemek isterse
        if(isRequired && showRequiredPlaces){
           return setIsError(true)
        }
        else{
            setIsError(false)
        }
    },[isRequired, data?.yukverenFiyat, showRequiredPlaces, showErrors])

    // useEffect(() => {
    //     if(data?.hedefNakliyefiyat < data?.yukverenFiyat && !freightInfo){
    //         localStorage.setItem("freightInfo", JSON.stringify(true))
    //         dispatch(showModal("freightInfo"))
    //     }
    // }, [data?.yukverenFiyat, data?.hedefNakliyefiyat])
     
    

  return (
    <Container value={text} radius={"5px"} isError={isError}>
        <NumericFormat type="text" id={"text"} thousandSeparator={'.'} decimalSeparator={','} suffix={` ${data?.fiyatlandirmaType?.text}`}  onChange={(e) => handleChange(e)} value={text} name={name}/> 
        <label htmlFor={"text"}>{labelText}{isRequired && "*"} </label>
    </Container>
  )
}

export default YukVerenFiyatInput